import { ROUTES } from '@/constants/routes'
import { SECTIONS } from '@/types/sections'
import { useNodeSection } from '@/composables/node/node-section'
import type { DeepAChatContextNode } from '@/pocs/chat/types'
import type { RouteLocationRaw } from 'vue-router'

export function useDeepAContextNodeName() {
  const { getNodeSectionTranslation } = useNodeSection()

  return function getContextNodeName(node: DeepAChatContextNode) {
    return getNodeSectionTranslation(node.displayName || node.name)
  }
}

export function getContextNodeRoute({
  nodeId,
  name,
}: DeepAChatContextNode): RouteLocationRaw {
  switch (name) {
    case SECTIONS.FILES:
      return { name: ROUTES.ROUTE_FILES }
    case SECTIONS.INBOX:
    case SECTIONS.QUEUE:
      return { name: ROUTES.ROUTE_QUEUE }
    case SECTIONS.TRASH:
      return { name: ROUTES.ROUTE_TRASH }
    default:
      return { name: ROUTES.ROUTE_FILES_NODE, params: { node: nodeId } }
  }
}
